import { render, staticRenderFns } from "./TwitterReply.vue?vue&type=template&id=532349d0&scoped=true&"
import script from "./TwitterReply.vue?vue&type=script&lang=js&"
export * from "./TwitterReply.vue?vue&type=script&lang=js&"
import style0 from "./TwitterReply.vue?vue&type=style&index=0&id=532349d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532349d0",
  null
  
)

export default component.exports